export type IconName =
  | 'plus'
  | 'minus'
  | 'trash'
  | 'pencil'
  | 'eye'
  | 'arrow-left'
  | 'arrow-right'
  | 'chevron-up'
  | 'chevron-down'
  | 'chevrons-up'
  | 'chevrons-down'
  | 'check'
  | 'x'
  | 'upload'
  | 'download'
  | 'save'
  | 'search'
  | 'user'
  | 'logout'
  | 'refresh'
  | 'settings'
  | 'archive'
  | 'file-text'
  | 'warning'
  | 'info'
  | 'arrow-up'
  | 'arrow-down'
  | 'hash'
  | 'eye-off'
  | 'external-link'
  | 'bell'
  | 'more-vertical'
  | 'palette'
  | 'calendar'
  | 'calendar-x'
  | 'star'
  | 'bookmark'
  | 'heart'
  | 'home'
  | 'folder'
  | 'list'
  | 'clock'
  | 'map-pin'
  | 'mail'
  | 'tag'
  | 'flag'
  | 'book'
  | 'users'
  | 'message-circle'
  | 'image'
  | 'link'
  | 'lock'
  | 'unlock'
  | 'share-2'
  | 'filter'
  | 'layers'
  | 'target'
  | 'thumbs-up'
  | 'globe'
  | 'sun'
  | 'moon'
  | 'smile'
  | 'help-circle'
  | 'clipboard'
  | 'check-circle'
  | 'alert-circle'
  | 'music'
  | 'video'
  | 'camera'
  | 'briefcase'
  | 'shopping-cart'
  | 'credit-card'
  | 'gift'
  | 'award'
  | 'zap'
  | 'activity'
  | 'grid'
  | 'layout'
  | 'printer'
  | 'phone'
  | 'copy'
  | 'rotate-cw'
  | 'dollar-sign'
  | 'database'
  | 'server'
  | 'cloud'
  | 'coffee'
  | 'headphones'
  | 'mic'
  | 'volume-2'
  | 'disc'
  | 'dumbbell'
  | 'ball'
  | 'watch'
  | 'trending-up'
  | 'compass'
  | 'shield'
  | 'columns'
  | 'check-square'
  | 'file'
  | 'maximize'
  | 'align-left'
  | 'align-center'
  | 'align-right'
  | 'separator-vertical'
  | 'apple'
  | 'carrot'
  | 'bread'
  | 'milk'
  | 'meat'
  | 'fish'
  | 'cheese'
  | 'egg'
  | 'banana'
  | 'orange'
  | 'lemon'
  | 'grape'
  | 'strawberry'
  | 'watermelon'
  | 'pepper'
  | 'onion'
  | 'potato'
  | 'mushroom'
  | 'broccoli'
  | 'corn'
  | 'pineapple'
  | 'avocado'
  | 'cherry'
  | 'croissant'
  | 'donut'
  | 'cupcake'
  | 'cookie'
  | 'cake'
  | 'butter'
  | 'yogurt'
  | 'ice-cream'
  | 'bacon'
  | 'sausage'
  | 'shrimp'
  | 'bottle'
  | 'wine-glass'
  | 'jar'
  | 'basket'
  | 'pumpkin';

export const ICON_NAMES: IconName[] = [
  'plus', 'minus', 'trash', 'pencil', 'eye', 'arrow-left', 'arrow-right',
  'chevron-up', 'chevron-down', 'chevrons-up', 'chevrons-down',
  'check', 'x', 'upload', 'download', 'save', 'search', 'user',
  'logout', 'refresh', 'settings', 'archive', 'file-text', 'warning',
  'info', 'arrow-up', 'arrow-down', 'hash', 'eye-off', 'external-link',
  'bell', 'more-vertical', 'palette', 'calendar', 'calendar-x',
  'star', 'bookmark', 'heart', 'home', 'folder', 'list', 'clock',
  'map-pin', 'mail', 'tag', 'flag', 'book', 'users', 'message-circle',
  'image', 'link', 'lock', 'unlock', 'share-2', 'filter', 'layers',
  'target', 'thumbs-up', 'globe', 'sun', 'moon', 'smile', 'help-circle',
  'clipboard', 'check-circle', 'alert-circle', 'music', 'video',
  'camera', 'briefcase', 'shopping-cart', 'credit-card', 'gift',
  'award', 'zap', 'activity', 'grid', 'layout', 'printer', 'phone',
  'copy', 'rotate-cw', 'dollar-sign', 'database', 'server', 'cloud',
  'coffee', 'headphones', 'mic', 'volume-2', 'disc', 'dumbbell', 'ball',
  'watch', 'trending-up', 'compass', 'shield', 'columns', 'check-square',
  'file', 'maximize', 'align-left', 'align-center', 'align-right', 'separator-vertical',
  'apple', 'carrot', 'bread', 'milk', 'meat', 'fish', 'cheese', 'egg',
  'banana', 'orange', 'lemon', 'grape', 'strawberry', 'watermelon', 'pepper', 'onion',
  'potato', 'mushroom', 'broccoli', 'corn', 'pineapple', 'avocado', 'cherry', 'croissant',
  'donut', 'cupcake', 'cookie', 'cake', 'butter', 'yogurt', 'ice-cream', 'bacon',
  'sausage', 'shrimp', 'bottle', 'wine-glass', 'jar', 'basket', 'pumpkin',
];
